import { ROUTES_CALENDAR } from '@/constants/routes';

export default {
    path: '/calendar',
    name: ROUTES_CALENDAR,
    meta: {
        requiresFocuses: true,
        requiresSpeedIntensities: true,
        requiresHeartRateIntensities: true,
        requiresStrokeRateIntensitiesRowing: true,
        requiresStrokeRateIntensitiesPaddling: true
    },
    component() {
        return import(/* webpackChunkName: 'calendar' */ '@/views/Calendar');
    }
};
